// extracted by mini-css-extract-plugin
module.exports = {"root":"layout_root__JrdRn","wrapper":"layout_wrapper__rL3Cu","content":"layout_content__UM4vb"};